// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ProposalStatus = {
    Pending: 'PENDING',
    Accepted: 'ACCEPTED',
    Rejected: 'REJECTED',
    Modified: 'MODIFIED'
} as const;
export type ProposalStatus = typeof ProposalStatus[keyof typeof ProposalStatus];


export function instanceOfProposalStatus(value: any): boolean {
    for (const key in ProposalStatus) {
        if (Object.prototype.hasOwnProperty.call(ProposalStatus, key)) {
            if (ProposalStatus[key as keyof typeof ProposalStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ProposalStatusFromJSON(json: any): ProposalStatus {
    return ProposalStatusFromJSONTyped(json, false);
}

export function ProposalStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalStatus {
    return json as ProposalStatus;
}

export function ProposalStatusToJSON(value?: ProposalStatus | null): any {
    return value as any;
}

export function ProposalStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): ProposalStatus {
    return value as ProposalStatus;
}
